import { Box, Input, InputGroup, InputRightAddon } from '@chakra-ui/react';
import { BiSearch } from 'react-icons/bi';
import { FilterDropdownProps, UseFilterConfigs } from '../useFilterConfigs';
import tinycolor from 'tinycolor2';
import ValueCheckbox from '../filterAtoms/ValueCheckbox';
import { useState } from 'react';
import { FilterValueMode, FilterValues } from '../../../../types';

interface ValueFilterProps
  extends Pick<FilterDropdownProps, 'stroke' | 'isDarkTheme'>,
    Pick<
      UseFilterConfigs,
      | 'cellValues'
      | 'filterValues'
      | 'valueMode'
      | 'toggleSelectAll'
      | 'selectValue'
    > {}

export default function ValueFilter({
  stroke,
  isDarkTheme,
  cellValues,
  valueMode,
  filterValues,
  selectValue,
  toggleSelectAll,
}: ValueFilterProps) {
  const [searchText, setSearchText] = useState('');
  const selectedValues = Object.keys(filterValues);
  const allSelected = areAllSelected(valueMode, cellValues, selectedValues);
  const visibleValues = cellValues.filter(({ key }) => {
    return key.includes(searchText.trim().toLowerCase());
  });

  const border = tinycolor(stroke)
    .lighten(isDarkTheme ? 1 : 7)
    .toString();

  // #region views
  const searchInput = (
    <InputGroup size="sm" variant="filled">
      <Input
        placeholder="Search"
        type="search"
        value={searchText}
        onChange={(e) => setSearchText(e.target.value)}
        fontSize="12px"
        rounded="2xl"
      />
      <InputRightAddon rounded="2xl" children={<BiSearch />} />
    </InputGroup>
  );

  const valuesContainer = (
    <Box rounded="2xl" my="3px" p="10px 5px" border={`1px solid ${border}`}>
      {/* <FixedSizeList
        height={_.subtract(300, 20)}
        itemCount={visibleValues.length}
        width={_.subtract(300, 20)}
        itemSize={35}
        className="custom-scrollbar"
      >
        {({ index, style }) => {
          const value = visibleValues[index];
          return (
            <ValueCheckbox
              style={style}
              key={index}
              valueKey={value.key}
              visibleValue={value.visibleValue}
              isSelected={isValueSelected(valueMode, filterValues, value.key)}
              onSelect={selectValue}
            />
          );
        }}
      </FixedSizeList> */}
    </Box>
  );

  const selectAllView = (
    <Box px="5px">
      <ValueCheckbox
        style={{ height: '35px', marginTop: '3px', fontSize: '13px' }}
        valueKey=""
        visibleValue="Select All"
        isIndeterminate={!!selectedValues.length}
        isSelected={allSelected}
        onSelect={(_, _1, val) => toggleSelectAll(val)}
        isDisabled={!cellValues.length}
      />
    </Box>
  );
  //   #endregion

  return (
    <Box>
      {searchInput}
      {selectAllView}
      {valuesContainer}
    </Box>
  );
}

// #region helpers
const areAllSelected = (
  valueMode: FilterValueMode,
  cellValues: UseFilterConfigs['cellValues'],
  selectedValues: string[]
) => {
  if (valueMode === FilterValueMode.Deselect) {
    return !selectedValues.length;
  } else {
    return selectedValues.length === cellValues.length;
  }
};

const isValueSelected = (
  valueMode: FilterValueMode,
  filterValues: FilterValues,
  value: string
) => {
  if (valueMode === FilterValueMode.Deselect) {
    return !filterValues[value];
  } else {
    return !!filterValues[value];
  }
};
// #endregion
